import { useLocation } from 'react-router-dom';

export const useRecipesLocation = () => {
  const location = useLocation();

  return {
    ...location,
    isSearchPage: location.pathname.includes('recipes/search'),
    isRecipesHomePage: location.pathname === '/ecom/recipes',
  };
};
